/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AfterContentInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList } from "@angular/core";
import { WizardTabComponent } from "./wizard-tab/wizard-tab.component";

@Component({
  selector: 'well-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements AfterContentInit {

  @Input() activeIndex = 0;

  @Output() activeIndexChange: EventEmitter<number> = new EventEmitter();

  @Input() isEdit = false;

  @Input() disabledSteps: boolean[] = [];

  @Input() showMenu = true;

  @Input() class = 'p';

  @ContentChildren(WizardTabComponent) inputTabs: QueryList<WizardTabComponent> | undefined = undefined;

  public tabs: WizardTabComponent[] | undefined = undefined;

  public ngAfterContentInit(): void {
    this.tabs = this.inputTabs?.toArray();

  }

  setIndex(index: any) {
    this.activeIndex = index;
    this.activeIndexChange.next(this.activeIndex);
  }

}
